<mat-card>
  <app-card-header
    [title]="title"
    [subtitle]="data.nombre"
    icono="content_copy"
    [botonCerrar]="true"
    (cerrar)="matDialogRef.close(false)"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <section class="inputs-group" style="flex-direction: column">
      <div>
        <app-cliente-selector [(ngModel)]="idCliente"></app-cliente-selector>
        <small class="ayuda">
          Se crea una copia de estos códigos para el cliente elegido.
        </small>
      </div>
    </section>

    @if (loading.getLoading()) {
      <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button
      irxBoton="secundario"
      type="button"
      (click)="matDialogRef.close(false)"
      [disabled]="loading.getLoading()"
    >
      {{ btnCancelText }}
    </button>
    <button
      irxBoton="principal"
      type="button"
      (click)="clonar()"
      [disabled]="loading.getLoading() || !idCliente"
    >
      <mat-icon>content_copy</mat-icon>
      {{ btnOkText }}
    </button>
  </mat-card-actions>
</mat-card>
